import { z } from "zod";
export const externalClientAppSchema = z.enum([
    "claude-code",
    "codex",
    "gemini",
    "chatgpt",
]);
